import React from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { ExceptionService } from 'app/core/status';
import { PageType, PageService } from 'app/core/page';
import { Exception } from 'app/core/status';
import { fade } from 'app/shared/styles';
import { PageModule } from './types';
import { EndingPageModule } from './Ending';
import { ExceptionModule } from './Exception';
import { PasswordPageModule } from './Password';
import { SurveyPageModule } from './Survey';
import { ThirdPartyLoginPageModule } from './ThirdPartyLogin';

/**
 * Only render the first page which `pageIf` returns true.
 */
const pageModules: PageModule[] = [
  ExceptionModule,
  PasswordPageModule,
  ThirdPartyLoginPageModule,
  SurveyPageModule,
  EndingPageModule
];

function renderPageModule(page: PageType, exception?: Exception) {
  let result;

  for (const pageModule of pageModules) {
    const { pageIf, render } = pageModule;

    if (pageIf(page, exception)) {
      result = render(page, exception);
      break;
    }
  }

  return result;
}

function Pages() {
  const page = PageService.usePage();
  const exception = ExceptionService.useException();

  return (
    <TransitionGroup>
      <CSSTransition
        key={exception ? exception.message : page}
        classNames={fade}
        timeout={250}
      >
        {renderPageModule(page, exception)}
      </CSSTransition>
    </TransitionGroup>
  );
}

export default Pages;
